import { render } from "./WelcomeScreen.vue?vue&type=template&id=5223b92c&scoped=true"
import script from "./WelcomeScreen.vue?vue&type=script&lang=js"
export * from "./WelcomeScreen.vue?vue&type=script&lang=js"

import "./installer-page.scss?vue&type=style&index=0&id=5223b92c&lang=scss&scoped=true"
import "./WelcomeScreen.vue?vue&type=style&index=1&id=5223b92c&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/installer/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5223b92c"]])

export default __exports__